import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const StayConnectedIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <circle cx="12" cy="2.8" r="2.3" />
      <path d="M3.3 11.8c-.4.4-.4 1.2 0 1.6.4.4 1.2.4 1.6 0l3.7-3.7v12.6c0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1v-5.8h2.3v5.7c0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.2-1.1v-14A8.2 8.2 0 0 0 21 1.8c.1-.6-.4-1.2-1-1.3h-.2c-.6 0-1 .4-1.1 1a6 6 0 0 1-5.6 4.8h-2.9c-1 0-2 .5-2.7 1.3l-4.2 4.2z" />
    </IconBase>
  );
};

export default StayConnectedIcon;
